import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCloseBoxIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={21}
    fill="none"
    viewBox="0 0 22 21"
    {...props}
  >
    <path
      fill="#000"
      d="M18.783 6.717a.14.14 0 0 1 0-.067.13.13 0 0 1 0-.058v-.075l-.056-.125a.4.4 0 0 0-.082-.092l-.082-.067h-.046l-3.612-2.075-3.41-1.916a.8.8 0 0 0-.266-.125h-.073a.8.8 0 0 0-.248 0h-.091a1.1 1.1 0 0 0-.303.108L3.667 6.1l-.083.058-.082.067-.092.058-.046.05-.055.125v.125a.5.5 0 0 0 0 .167v7.275c0 .142.04.281.115.405a.9.9 0 0 0 .316.303l6.875 3.867.137.05h.074a.86.86 0 0 0 .476 0h.074l.137-.05 6.82-3.808a.9.9 0 0 0 .317-.304.8.8 0 0 0 .114-.405V6.808s.018-.058.018-.091M11 3.925l1.632.917-5.124 2.883-1.641-.917zm-.917 12.5-5.041-2.8V8.3l5.041 2.833zM11 9.667l-1.75-.959 5.123-2.891 1.76.991zm5.958 3.933-5.041 2.85v-5.317L16.958 8.3z"
    />
  </svg>
);
export default SvgCloseBoxIcon;
